'use client';

import { useEffect } from 'react';
import { Toaster as Sonner } from 'sonner';
import { markToasterReady } from '@/core/utils/toast';

export function Toaster() {
    useEffect(() => {
        markToasterReady();
    }, []);

    return (
        <Sonner
            position="top-right"
            richColors
            closeButton
            theme="light"
            toastOptions={{
                className: 'font-sans',
            }}
        />
    );
}
